export class Language {
    public  userId : number;
    public languageId:number;
    public languageName: string;
    public code: string;
    public status :string;
}
